import React from "react";

function ConsumoCartao({ reportData }) {
  const totalCredito = reportData[0]?.credito?.reduce(
    (acc, item) => acc + Number(item.TOTAL),
    0
  );

  const totalDebito = reportData[0]?.debito?.reduce(
    (acc, item) => acc + Number(item.TOTAL),
    0
  );

  const valorTotal = totalCredito - totalDebito;
  const saldoDesbloqueado =
    valorTotal -
    reportData[0]?.VALORCARTAO -
    valorTotal * reportData[0]?.SALDORES * 0.01;

  return (
    <div className="flex flex-col p-4 gap-12 justify-center items-center">
      <div className="flex box-border flex-col rounded-lg shadow-lg mt-2 p-4 gap-4 justify-center items-center w-full">
        <div className="box-border overflow-x-auto w-full">
          <table className="min-w-full bg-white border border-solid border-gray-300">
            <tbody>
              <tr>
                <td className="font-Roboto px-4 py-2 border-b text-sm">
                  Valor do Cartão
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                  {Number(reportData[0]?.VALORCARTAO).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </td>
              </tr>
              <tr>
                <td className="font-Roboto px-4 py-2 border-b text-sm">
                  Saldo Residual
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                  {Number(reportData[0]?.SALDORES).toLocaleString("pt-BR", {
                    style: "percent",
                    currency: "BRL",
                  })}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="flex flex-col gap-4 justify-start w-full w-full text-center">
          <h2 className="font-Oswald ">Créditos</h2>
        </div>
        <table className="min-w-full bg-white border border-solid border-gray-300">
          <thead className="bg-gray-300">
            <tr>
              <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600]">
                Data/Hora
              </th>
              <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600]">
                PDV
              </th>
              <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600]">
                Turno/Operador
              </th>
              <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600]">
                Produto
              </th>
              <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right ">
                Valor Unitário
              </th>
              <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right ">
                Quantidade
              </th>
              <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right ">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            {reportData[0]?.credito?.map((credito, index) => (
              <tr key={index}>
                <td className="font-Roboto px-4 py-2 border-b text-sm">
                  {new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  }).format(new Date(credito.DATAHORA))}
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm ">
                  {credito.PDV}
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm ">
                  {credito.TURNO} - {credito.RESPONSAVEL}
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm ">
                  {credito.CODPROD} - {credito.DESCPROD}
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                  {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(credito.VALORUNI)}
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                  {credito.QTDE}
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                  {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(credito.TOTAL)}
                </td>
              </tr>
            ))}
            <tr className="bg-gray-300">
              <td
                colSpan={6}
                className="font-Roboto px-4 py-2 border-b text-sm font-semibold text-right"
              >
                Total de Créditos
              </td>
              <td className="font-Roboto px-4 py-2 border-b text-sm text-right font-semibold">
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(totalCredito)}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="flex flex-col gap-4 justify-start w-full w-full text-center">
          <h2 className="font-Oswald ">Débitos</h2>
        </div>
        <table className="min-w-full bg-white border border-solid border-gray-300">
          <thead className="bg-gray-300">
            <tr>
              <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600]">
                Data/Hora
              </th>
              <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600]">
                PDV
              </th>
              <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600]">
                Turno/Operador
              </th>
              <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600]">
                Produto
              </th>
              <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right ">
                Valor Unitário
              </th>
              <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right ">
                Quantidade
              </th>
              <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right ">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            {reportData[0]?.debito?.map((credito, index) => (
              <tr key={index}>
                <td className="font-Roboto px-4 py-2 border-b text-sm">
                  {new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  }).format(new Date(credito.DATAHORA))}
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm ">
                  {credito.PDV}
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm ">
                  {credito.TURNO} - {credito.RESPONSAVEL}
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm ">
                  {credito.CODPROD} - {credito.DESCPROD}
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                  {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(credito.VALORUNI)}
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                  {credito.QTDE}
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                  {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(credito.TOTAL)}
                </td>
              </tr>
            ))}
            <tr className="bg-gray-300">
              <td
                colSpan={6}
                className="font-Roboto px-4 py-2 border-b text-sm font-semibold text-right"
              >
                Total de Débitos
              </td>
              <td className="font-Roboto px-4 py-2 border-b text-sm text-right font-semibold">
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(totalDebito)}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="box-border overflow-x-auto w-full">
          <table className="min-w-full bg-white border border-solid border-gray-300 font-bold">
            <tbody>
              <tr>
                <td className="font-Roboto px-4 py-2 border-b text-sm">
                  Saldo Total
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                  {Number(valorTotal).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </td>
              </tr>
              <tr>
                <td className="font-Roboto px-4 py-2 border-b text-sm">
                  Saldo Desbloqueado
                </td>
                <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                  {Number(saldoDesbloqueado).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ConsumoCartao;
